import { motion } from "framer-motion";
import SectionHeading from "./SectionHeading";
import { useTr } from "@/i18n";

const photos = [
  { src: "/assets/matrimonio2.webp", w: 1114, h: 797, alt: "Matrimonio con coriandoli e photobooth 360", caption: "Wedding — Party 360°", tall: true },
  { src: "/assets/locale-festa-luci-sera.webp", w: 1599, h: 899, alt: "Festa in un locale del Ticino con luci da discoteca di DJ Magix", caption: "Live — Luci in Locale", tall: false },
  { src: "/assets/gallery3.webp", w: 976, h: 1300, alt: "Console DJ in discoteca", caption: "Console — Club Night", tall: false },
  { src: "/assets/festa-paese-lugano-sera.webp", w: 1500, h: 2000, alt: "Folla alla festa di paese serale sul lungolago con DJ Magix", caption: "Festa di Paese — Sera", tall: true },
  { src: "/assets/gallery4.webp", w: 800, h: 1200, alt: "Scintille dorate", caption: "Scintille", tall: false },
  { src: "/assets/gallery5.webp", w: 1880, h: 1253, alt: "Sposi tra le scintille", caption: "Wedding — First Dance", tall: false },
];

const onSpot = (e) => {
  const r = e.currentTarget.getBoundingClientRect();
  e.currentTarget.style.setProperty("--mx", `${e.clientX - r.left}px`);
  e.currentTarget.style.setProperty("--my", `${e.clientY - r.top}px`);
};

export default function Gallery() {
  const tr = useTr();
  const trPhotos = tr("gallery.items", photos);
  const items = photos.map((p, i) => ({ ...p, ...(trPhotos[i] || {}) }));
  return (
    <section id="galleria" className="py-24 bg-[#0B0B0B]">
      <div className="max-w-7xl mx-auto">
        <SectionHeading
          eyebrow={tr("gallery.eyebrow", "Galleria")}
          title={tr("gallery.title", "Atmosfere & Momenti d'Oro")}
          accent={tr("gallery.accent", "Scorci delle serate che hanno fatto ballare la Svizzera.")}
          testid="gallery-heading"
        />
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 px-6">
          {items.map((p, i) => (
            <motion.figure
              key={p.src}
              data-testid={`gallery-photo-${i}`}
              onMouseMove={onSpot}
              className="spotlight gold-frame rounded-xl overflow-hidden group relative"
              initial={{ opacity: 0, scale: 0.96, y: 20 }}
              whileInView={{ opacity: 1, scale: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.55, delay: (i % 3) * 0.1, ease: [0.22, 1, 0.36, 1] }}
            >
              <img
                src={p.src}
                srcSet={`${p.src.replace(".webp", "-480.webp")} 480w, ${p.src.replace(".webp", "-768.webp")} 768w, ${p.src} ${p.w}w`}
                sizes="(max-width: 768px) 100vw, 33vw"
                alt={p.alt}
                width={p.w}
                height={p.h}
                loading="lazy"
                className={`w-full object-cover saturate-[0.92] transition-all duration-700 group-hover:scale-105 group-hover:saturate-100 ${
                  p.tall ? "h-80" : "h-64"
                }`}
              />
              <figcaption className="absolute bottom-0 inset-x-0 z-[3] bg-gradient-to-t from-black/85 to-transparent px-5 pb-4 pt-10">
                <span className="font-accent italic text-base text-[#F7DE8B] opacity-0 translate-y-2 transition-all duration-500 group-hover:opacity-100 group-hover:translate-y-0 inline-block">
                  {p.caption}
                </span>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
